import styled from 'styled-components'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import { Noto_body2_b14, Noto_body3_b12, Noto_body3_r12 } from 'src/styles/fonts/NotoSansKrFonts'
import main_map_open_icon from 'src/assets/images/main/main_map_open.png'
import usePageNav from 'src/hooks/usePageNav.hook'
import { mediaMaxWidth } from 'src/styles/mixin'

const MainMapShortcut = () => {
  const { couponMapPageNav } = usePageNav()
  return (
    <S.MainMapShortcutContainer $option="flex_row">
      <S.MainMapShortcut.Container $option="flex_row_space_between" $column_gap="10px">
        <S.MainMapShortcut.MapIcon src={main_map_open_icon} />
        <S.MainMapShortcut.TextContainer $option="flex_column">
          <Typography $fontStyle={Noto_body2_b14}>내 주변 혜택 바로 사용해요!</Typography>
          <Typography $fontStyle={Noto_body3_r12} $color="var(--black-40)">
            5분거리에서 바로 사용
          </Typography>
        </S.MainMapShortcut.TextContainer>
        <S.MainMapShortcut.OpenChips>
          <Typography $fontStyle={Noto_body3_b12} $color="var(--white)" onClick={couponMapPageNav}>
            지도보기
          </Typography>
        </S.MainMapShortcut.OpenChips>
      </S.MainMapShortcut.Container>
    </S.MainMapShortcutContainer>
  )
}
export default MainMapShortcut

const S = {
  MainMapShortcutContainer: styled(Container)`
    max-width: 420px;
    ${mediaMaxWidth('460')} {
      max-width: unset;
      padding: 0 20px;
    }
    margin: 0 auto;
  `,
  MainMapShortcut: {
    Container: styled(Container)`
      padding: 12px 18px;
      border-radius: 12px;
      border: 1px solid var(--brand-20);
      background: var(--brand-5);
      align-items: center;
    `,
    TextContainer: styled(Container)``,
    OpenChips: styled.section`
      display: flex;
      border-radius: 20px;
      background: var(--brand-50);
      padding: 4px 8px;
      min-width: 61px;
      width: fit-content;
      cursor: pointer;
    `,
    MapIcon: styled.img`
      width: 42px;
      height: 42px;
    `,
  },
}
